import Component from '../core/Component';
import $ from 'jquery';
import keycodes from 'keycodes';

export default class Search extends Component {

    constructor($element) {
        super($element);
        this.$scope = this.$element.parent('.header__search');
        this.$input = this.$scope.find('input');
        this.$document = $(document);
    }

    prepare() {
        this.$scope.on('click', (event) => {
            event.stopPropagation();
        });
        this.$element.on('click', ::this.toggleSearch);
        this.$document
            .on('click', ::this.closeSearch)
            .on('keyup', ::this.checkEsc);
    }

    STATE = false;

    destroy() {
        this.$document.off('click', ::this.closeSearch);
    }

    toggleSearch (event) {
        if (this.STATE) {
            this.$scope.removeClass('show');
            this.STATE = false;
        } else {
            this.$scope.addClass('show');
            this.STATE = true;
            setTimeout(() => {
                this.$input.focus();
            }, 100);
        }
    }

    closeSearch (event) {
        if (this.STATE) {
            this.$scope.removeClass('show');
            this.STATE = false;
        }
    }

    checkEsc(event) {
        if (event.keyCode == keycodes('esc')) {
            this.closeSearch();
        }
    }
}



// WEBPACK FOOTER //
// ./components/Search.js